import React, { useState } from 'react';

const Input = ({label, icon, placeholder, value, onChange, type, borderColor, disabled = false, helperText, helperVariant, className = '', variant}) => {
  const [isFocused, setIsFocused] = useState(false);
  const handleFocus = () => {
    if (!disabled) setIsFocused(true);
  };
  const handleBlur = () => {
    if (!disabled) setIsFocused(false);
  };



  const isAuth = variant === 'auth';
  let color = 'var(--stroke-contrast-mid)';

  if (isFocused) {
    if (borderColor) {
      color = borderColor
    }
    else {
      color = 'var(--primary-dark)';
    }
  }

  const helperClassName = helperVariant ? `help-text ${helperVariant}` : 'help-text';

  const wrapperStyle = isAuth ? {} : { '--input-border': color };

  return (
    <div className={`input${disabled ? ' is-disabled' : ''}${isAuth ? ' input-auth' : ''}${className ? ` ${className}` : ''}`}
         style={wrapperStyle}>
      {label && (
        <span className="input-label">
          {label}
        </span>
      )}

      <div className="input-row">
        <input type={type ? type : 'text'}
               onFocus={handleFocus}
               onBlur={handleBlur}
               placeholder={placeholder}
               value={value}
               onChange={onChange}
               disabled={disabled}
               aria-disabled={disabled}
               className={`input-field${isAuth ? ' input-field-auth' : ''}`} />
        {icon && (
          <div className="input-icon">
            {icon}
          </div>
        )}
      </div>
      {helperText && (
        <span className={helperClassName}>
          {helperText}
        </span>
      )}
    </div>
  );
}

export default Input;
